import parseDialogue from "../../util/parseDialogue";

export const SuperphreakD2 = parseDialogue(`
superphreak:d2:100-700

#100 Ok, I'm finally back on the net. Hey, news on the S.M.A.R.T bug.
>200 Go for it.

#200 Looks like it must have been an inside job. Just happened too quickly. The hacker had the passwords.
>300 Do you have any idea who's responsible? 
>301 So what do we do?

#300 A couple ideas, but nothing definite. I'l keep working on it. Still, as the only S.M.A.R.T agent left, you'll have to handle the net problems.
>400 Actually, another agent wrote me.
>401 What about Disarray?

#301 I'll keep working on getting S.M.A.R.T on its feet. Since you're hte only S.M.A.R.T agent left, you'll have to handle the net problems.
>400 Actually, I talked to another agent.
>401 What about Disarray?

#400 Hold on. Not possible. S.M.A.R.T's down. Who was this agent?
>500 His name was Disarray.

#401 Disarray? What do you know about Disarray?
>500 Nothing much.

#500 If you're talking about who I think you are, that's bad news. I was training an agent named Disarray a couple of months ago. He got thrown out for being the reckless and greedy loser that he is. Don't trust a word he says.
>600 What do we do about him?
>600 He asked me to do a mission.

#600 ~~ ~~~~ ~ Don't have a lot of time left. I'll start tracing Disarray. Go along with his idea so I can see what he's doing. Oh, and ~ ~~~~ ~~~~~ ~ ~~ ~
>700 Close
`);
